import { useContext } from "react";

import { ClubCurrencyContext } from "./ClubCurrencyContext";
import {
  DEFAULT_CURRENCY_CODE,
  DEFAULT_CURRENCY_SYMBOL,
} from "./convertCurrencyCodeToSymbol";

const defaultCurrency = {
  currencyCode: DEFAULT_CURRENCY_CODE,
  currencySymbol: DEFAULT_CURRENCY_SYMBOL,
} as const;

export const useGetClubCurrency = () => {
  try {
    const context = useContext(ClubCurrencyContext);

    if (!context) {
      return defaultCurrency;
    }

    return context;
  } catch (error) {
    return defaultCurrency;
  }
};
